export const PASSWORD_MIN_LENGTH = 8
export const LOCAL_STORAGE_CT_CART_UPDATED = 'ct_cartUpdated'
export const LOCAL_STORAGE_CT_ACCESS_TOKEN_ANONYMOUS = 'ct_tokenAnonymous'
export const LOCAL_STORAGE_CT_ACCESS_TOKEN_CUSTOMER = 'ct_tokenCustomer'
export const CART_FIXED = "cart fixed"
export const CART_NOT_FIXED = "no need to fix cart"